import React from 'react';
import { SvgIconProps } from '../IconProps';
import * as Colors from '../../constants/Colors';
import { BaseSvgIcon } from '../BaseSvgIcon';

export type PlusIconProps = SvgIconProps & {
    color?: keyof typeof Colors;
    strokeWidth?: number;
};

export const PlusIcon = ({ color, strokeWidth, ...props }: PlusIconProps) => (
    <BaseSvgIcon viewBox="0 0 23 23" fill="none" {...props}>
        <g fill="none" fillRule="evenodd" strokeLinecap="round">
            <g stroke={color ? Colors[color] : 'currentColor'} strokeWidth={strokeWidth}>
                <path
                    d="M19 9.5L0 9.5M9.5 19L9.5 0"
                    transform="translate(-937 -599) translate(912 579) translate(27 22)"
                />
            </g>
        </g>
    </BaseSvgIcon>
);

PlusIcon.defaultProps = {
    alt: 'Plus icon',
    width: '23px',
    height: '23px',
    strokeWidth: 3,
};
